import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import { getters, actions } from "Portal/PortalHome/model";
import { withRouter } from "react-router";
import Notifications from "./Notifications";
import * as R from "ramda";
import Page from "Portal/Page";
import Sessions from "./Sessions";
import Applications from "./Applications";
import Activities from "./Activities";
import Files from "./Files";
import Pages from "./Pages";
import Links from "./Links";
import CSSModules from "react-css-modules";
import css from "./styles.scss";
import {
  getLogoImageUrl,
  getLogoImageAltText,
  getBackgroundImageUrl,
  getPortalNameColor,
  getPortalNameFont,
  getPortalNameSize,
  getCssCode,
  getBackgroundImageAltText
} from "../selectors";
import { Style } from "react-style-tag";

const decorate = R.compose(
  withRouter,
  connect(
    state => ({
      title: getters.title(state),
      description: getters.description(state),
      logoImageUrl: getLogoImageUrl(state),
      logoImageAltText: getLogoImageAltText(state),
      backgroundImageUrl: getBackgroundImageUrl(state),
      backgroundImageAltText: getBackgroundImageAltText(state),
      portalNameColor: getPortalNameColor(state),
      portalNameFont: getPortalNameFont(state),
      portalNameSize: getPortalNameSize(state),
      cssCode: getCssCode(state),
      showTasks: getters.show_tasks(state),
      percent_complete: getters.percent_complete(state),
      filters: getters.filters(state)
    }),
    { init: actions.init }
  ),
  CSSModules(css)
);

const Layout = ({
  init,
  scope,
  title,
  description,
  logoImageUrl,
  logoImageAltText,
  backgroundImageUrl,
  backgroundImageAltText,
  showTasks,
  location,
  portalNameColor,
  portalNameFont,
  portalNameSize,
  cssCode
}) => {
  const tasksRef = useRef(null);
  const scrollToTasks = () => tasksRef.current.scrollIntoView();

  useEffect(() => {
    init({
      scope,
      fileRequestTypeId: location.query.fileRequestTypeId,
      accountId: location.query.accountId,
      contactId: location.query.contactId
    });
  }, [init]);

  return (
    <>
      {cssCode ? <Style>{cssCode}</Style> : null}
      <Page
        instanceId="home"
        title={title}
        description={description}
        logoImageUrl={logoImageUrl}
        logoImageAltText={logoImageAltText}
        backgroundImageUrl={backgroundImageUrl}
        backgroundImageAltText={backgroundImageAltText}
        titleStyle={{
          fontFamily: portalNameFont,
          fontSize: portalNameSize,
          color: portalNameColor
        }}
      >
        {showTasks && <Notifications scrollToTasks={scrollToTasks} />}
        <Applications />
        <Sessions />
        {showTasks && (
          <>
            <Activities tasksRef={tasksRef} />
            <Files />
            <Pages />
          </>
        )}
        <Links />
      </Page>
    </>
  );
};

export default R.compose(decorate)(Layout);
